/**
 * global.js — Mavin Parfum
 * Mobile menu open/close, focus trap, and other UI glue.
 */
(function() {
  'use strict';

  // Portal mobile menu panel + overlay OUT of sticky nav to escape z-index trap
  document.querySelectorAll('details[data-mobile-menu]').forEach(menu => {
    const panel = menu.querySelector('.mobile-menu__panel');
    const overlay = menu.querySelector('.mobile-menu__overlay');
    if (panel) document.body.appendChild(panel);
    if (overlay) document.body.appendChild(overlay);

    menu.addEventListener('toggle', () => {
      if (menu.open) {
        document.body.classList.add('mobile-menu-is-open');
        document.body.style.overflow = 'hidden';
      } else {
        document.body.classList.remove('mobile-menu-is-open');
        document.body.style.overflow = '';
      }
    });
  });

  // Click on overlay or close button
  document.addEventListener('click', e => {
    const closeBtn = e.target.closest('[data-mobile-menu-close]');
    if (closeBtn) {
      const menu = document.querySelector('details[data-mobile-menu]');
      if (menu) menu.removeAttribute('open');
    }
  });

  // Escape closes menu
  document.addEventListener('keydown', e => {
    if (e.key !== 'Escape') return;
    const openMenu = document.querySelector('details[data-mobile-menu][open]');
    if (openMenu) openMenu.removeAttribute('open');
  });

  // Announce active nav link
  const path = window.location.pathname;
  document.querySelectorAll('.nav-link').forEach(a => {
    if (a.getAttribute('href') === path) a.classList.add('active');
  });

  // Auto-submit filter form on checkbox change
  document.querySelectorAll('form[data-auto-submit]').forEach(form => {
    form.addEventListener('change', e => {
      if (e.target.matches('input[type="checkbox"], input[type="number"], select')) {
        form.submit();
      }
    });
  });

  // Lazy-reveal on scroll for .animate-in elements
  if ('IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    const io = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -10% 0px' });
    document.querySelectorAll('.animate-in').forEach(el => io.observe(el));
  } else {
    document.querySelectorAll('.animate-in').forEach(el => el.classList.add('is-visible'));
  }
})();
